import { buildChartTheme } from '@visx/xychart';

import { AXIS_TICK_LENGTH_PX, CHART_FONT_SIZE_CSS_VAR } from '../constants';

/**
 * Builds a LaunchPad-themed chart theme for use with visx XYChart.
 * Provides consistent styling across all chart components.
 *
 * @returns A theme object compatible with visx's buildChartTheme
 */
export function buildLaunchPadChartTheme() {
  return buildChartTheme({
    backgroundColor: 'transparent',
    colors: [], // Colors will be assigned per-series
    gridColor: 'var(--lp-color-border-ui-primary)',
    gridColorDark: 'var(--lp-color-border-ui-secondary)',
    svgLabelSmall: {
      fill: 'var(--lp-color-text-ui-secondary)',
      fontFamily: 'var(--lp-font-family-base)',
      fontSize: `var(${CHART_FONT_SIZE_CSS_VAR})`,
      fontStyle: 'normal',
      fontWeight: 'var(--lp-font-weight-medium)',
      lineHeight: '1.2em', // Static value required; CSS vars break visx's SVG <tspan> dy attribute
    },
    svgLabelBig: {
      fill: 'var(--lp-color-text-ui-secondary)',
      fontSize: 14,
      fontFamily: 'var(--lp-font-family-ui)',
      fontWeight: 500,
    },
    tickLength: AXIS_TICK_LENGTH_PX,
  });
}
